import React, { createContext, useReducer } from 'react';

import { DraftSaveReducer, initialState } from '../reducers/DraftSaveReducer';
import {OPERATIONS} from "../../util/Constants";
import {chainWalk, isValid} from "../../util/Util";

export const DraftContext = createContext();

const DraftContextProvider = (props) => {

  const [draftData, dispatchDraft] = useReducer(DraftSaveReducer, initialState);

  const setDraftData = ({data, stateKey, subKey, allRowsAdded, override}) => {
    if(!isValid(stateKey) || !isValid(subKey) || !Array.isArray(data)) return;
    const prevData = chainWalk(() => draftData[stateKey][subKey].data, null);
    if(prevData && !override) return;
    const editedData = data.map((instance) => {
      return {
        ...instance,
        operation: allRowsAdded ? OPERATIONS.ADD : OPERATIONS.NO_OP
      }
    })
    dispatchDraft({type: "SET_DATA", data: {data: editedData, stateKey, subKey, allRowsAdded}});
  }

  const addInstance = ({stateKey, subKey, instance}) => {
    if(!isValid(stateKey) || !isValid(instance)) return;
    instance.operation = OPERATIONS.ADD;
    dispatchDraft({type: "ADD_INSTANCE", data: {stateKey, subKey, newInstance: instance}});
  }

  const editInstance = ({stateKey, subKey, instance, keyComparator, valueComparator}) => {
    if(!isValid(stateKey) || !isValid(instance) || !isValid(keyComparator)) return;
    dispatchDraft({type: "EDIT_INSTANCE", data: {stateKey, subKey, newInstance: instance, keyComparator, valueComparator}});
  }

  const deleteInstance = ({stateKey, subKey, keyComparator}) => {
    if(!isValid(stateKey) || !isValid(keyComparator)) return;
    dispatchDraft({type: "DELETE_INSTANCE", data: {stateKey, subKey, keyComparator}});
  }

  const deleteAll = ({stateKey, subKey}) => {
    if(!isValid(stateKey) || !isValid(subKey)) return;
    dispatchDraft({type: "DELETE_ALL", data: {stateKey, subKey}});
  }

  const resetDraftData = (stateKeys, subKey) => {
    if(!isValid(stateKeys) || !Array.isArray(stateKeys)) return;
    stateKeys.forEach((stateKey) => dispatchDraft({type: "RESET_DATA", data: {stateKey, subKey}}));
  }

  const getDraftData = ({stateKey, subKey}) => {
    if(!isValid(stateKey) || !isValid(subKey)) return;
    return chainWalk(() => draftData[stateKey][subKey].data, []);
  }

  const getFilteredDraftData = ({stateKey, subKey}) => {
    if(!isValid(stateKey) || !isValid(subKey)) return;
    let filteredData = chainWalk(() => draftData[stateKey][subKey].data, [])
      .filter((instance) => (instance.operation !== OPERATIONS.DELETE));
    return filteredData.map((instance) => {
      const editedInstance = {...instance};
      if("operation" in editedInstance) delete editedInstance.operation;
      if("prev" in editedInstance) delete editedInstance.prev;
      return editedInstance;
    })
  }

  const isDataEdited = (stateKeys) => {
    if(!isValid(stateKeys)) return false;
    let isEdited = false;
    stateKeys.forEach((stateKey) => {
      if(!isValid(stateKey)) return;
      Object.keys(draftData[stateKey]).forEach((subKey) => {
        draftData[stateKey][subKey].data.forEach((instance) => {
          if(instance.operation !== OPERATIONS.NO_OP) {
            isEdited = true;
          }
        })
      })
    })
    return isEdited;
  }

  const value = {
    setDraftData,
    getDraftData,
    getFilteredDraftData,
    resetDraftData,
    addInstance,
    editInstance,
    deleteInstance,
    isDataEdited,
    deleteAll
  }
  return <DraftContext.Provider value={value}>{props.children}</DraftContext.Provider>;
};

export default DraftContextProvider;



// WEBPACK FOOTER //
// ./src/components/draftSave/context/DraftSaveContext.js